import React, { useEffect, useState } from 'react';
import moment from 'moment';
import CanvasJSReact_ChartPerformance from '../../../components/chart/ChartPerformance';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';
import {
    commonlibs_getfirstplot_mode
} from '../../ComLibrary.js';

function MeasurementPerformance(props) {
    const [chart_mode, setChart_mode] = useState('daily-h');
    const [data_chart, setData_chart] = useState({
        chart_5m: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
            Summary_Unit: {},
        },
        chart_hour: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
            Summary_Unit: {},
        },
        chart_month: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
            Summary_Unit: {},
        },
        chart_year: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
            Summary_Unit: {},
        }
    });
    const [chart_plot, setChart_plot] = useState({
        XLabel: '',
        Energy: [],
        PR: [],
        ORx: [],
        ENS: [],
        Saving: [],
        Value: [],
        CO2: [],
        errorx: [],
        CODData: null,
        Chart1_Style: { unit: "kWh", digit: 0, type: "line", axis_y1: 'Power (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-', start: null },
        Chart2_Style: { unit: "kWh", digit: 0, type: "line", axis_y1: 'Power (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-', start: null },
        Chart3_Style: { unit: "kWh", digit: 0, type: "line", axis_y1: 'Power (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-', start: null },
        Chart4_Style: { unit: "kWh", digit: 0, type: "line", axis_y1: 'Power (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-', start: null },
        Chart5_Style: { unit: "kWh", digit: 0, type: "line", axis_y1: 'Power (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-', start: null },
        Chart6_Style: { unit: "kWh", digit: 0, type: "line", axis_y1: 'Power (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-', start: null },
        Chart7_Style: { unit: "kWh", digit: 0, type: "line", axis_y1: 'Power (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-', start: null },
        summary: {
            Energy: 0,
            PRx: 0,
            ORx: 0,
            ENS: 0,
            Saving: 0,
            Value: 0,
            CO2: 0
        },
        summary_unit: {
            Energy: "-",
            PRx: "-",
            ORx: "-",
            ENS: "-",
            Saving: "-",
            Value: "-",
            CO2: "-",
        },
        unit_rate: [],
        unit_rate_onpeak: [],
        unit_rate_offpeak: [],
        co2_factor: []
    });

    useEffect(() => {
        return () => {
            setData_chart({})
            setChart_plot({})
        };
    }, []);

    useEffect(() => {
        if (props.data_chart !== undefined) {
            if (props.data_chart.chart_hour !== undefined) {
                if (props.data_chart.chart_hour.Data !== null) {
                    setData_chart(props.data_chart)
                }
            }
        }
    }, [props.data_chart]);

    useEffect(() => {
        let daplot
        if (chart_mode === "daily-h") {
            daplot = {
                XLabel: data_chart.chart_hour.XLabel,
                Energy: [],
                PR: [],
                PRG: [],
                ORx: [],
                ORG: [],
                ENS: [],
                Saving: [],
                Saving_usage: [],
                Saving_ft: [],
                Value: [],
                Value_usage: [],
                Value_ft: [],
                CO2: [],
                errorx: [],
                CODData: null,
                Chart1_Style: { unit: "kWh", digit: 2, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null },
                Chart2_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null },
                Chart3_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null },
                Chart4_Style: { unit: "kWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null },
                Chart5_Style: { unit: "kgCO<sub>2</sub>", digit: 3, type: "column", axis_y1: 'CO2 Reduction (kgCO2)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null },
                Chart6_Style: { unit: "THB", digit: 2, type: "column", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null },
                Chart7_Style: { unit: "THB", digit: 2, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical', start: null },
                summary: { Energy: 0, PRx: 0, ORx: 0, ENS: 0, Saving: 0, Value: 0, CO2: 0 },
                summary_unit: { Energy: "-", PRx: "-", ORx: "-", ENS: "-", Saving: "-", Value: "-", CO2: "-", },
                unit_rate: [],
                ft_val: [],
                co2_factor: [],
                holiday: []
            }
            if (data_chart.chart_hour.Data[0] !== undefined) {
                daplot.Chart2_Style.start = new Date(data_chart.chart_hour.Data[0].x)
                daplot.Chart3_Style.start = new Date(data_chart.chart_hour.Data[0].x)
                for (let i = 0; i < data_chart.chart_hour.Data.length; i++) {
                    const dx = new Date(data_chart.chart_hour.Data[i].x)

                    daplot.Energy.push({ x: dx, y: data_chart.chart_hour.Data[i]['solar'] })
                    daplot.PR.push({ x: dx, y: data_chart.chart_hour.Data[i]['pr_ens'] })
                    daplot.PRG.push({ x: dx, y: data_chart.chart_hour.Data[i]['prg'] })
                    daplot.ORx.push({ x: dx, y: data_chart.chart_hour.Data[i]['orx_ens'] })
                    daplot.ORG.push({ x: dx, y: data_chart.chart_hour.Data[i]['org'] })
                    daplot.ENS.push({ x: dx, y: data_chart.chart_hour.Data[i]['ens'] })
                    daplot.Saving.push({ x: dx, y: data_chart.chart_hour.Data[i]['saving'] })
                    daplot.Saving_usage.push(data_chart.chart_hour.Data[i]['saving_hourly'])
                    daplot.Saving_ft.push(data_chart.chart_hour.Data[i]['saving_ft'])
                    daplot.Value.push({ x: dx, y: data_chart.chart_hour.Data[i]['value'] })
                    daplot.Value_usage.push(data_chart.chart_hour.Data[i]['value_hourly'])
                    daplot.Value_ft.push(data_chart.chart_hour.Data[i]['value_ft'])
                    daplot.CO2.push({ x: dx, y: data_chart.chart_hour.Data[i]['co2'] })

                    daplot.unit_rate.push(data_chart.chart_hour.Data[i]['unit_rate'])
                    daplot.ft_val.push(data_chart.chart_hour.Data[i]['ft_val'])
                    daplot.co2_factor.push(data_chart.chart_hour.Data[i]['co2_factor'])
                    daplot.errorx.push(data_chart.chart_hour.Data[i]['error'])
                    daplot.holiday.push(data_chart.chart_hour.Data[i]['holiday'])
                }
                daplot.summary.Energy = data_chart.chart_hour.Summary['sum_energy']
                daplot.summary.PRx = data_chart.chart_hour.Summary['pr_ens']
                daplot.summary.ORx = data_chart.chart_hour.Summary['orx_ens']
                daplot.summary.ENS = data_chart.chart_hour.Summary['sum_ens']
                daplot.summary.Saving = data_chart.chart_hour.Summary['sum_saving']
                daplot.summary.Value = data_chart.chart_hour.Summary['sum_value']
                daplot.summary.CO2 = data_chart.chart_hour.Summary['sum_co2']

                daplot.summary_unit.Energy = data_chart.chart_hour.Summary_Unit['sum_energy']
                daplot.summary_unit.PRx = data_chart.chart_hour.Summary_Unit['pr_ens']
                daplot.summary_unit.ORx = data_chart.chart_hour.Summary_Unit['orx_ens']
                daplot.summary_unit.ENS = data_chart.chart_hour.Summary_Unit['sum_ens']
                daplot.summary_unit.Saving = data_chart.chart_hour.Summary_Unit['sum_saving']
                daplot.summary_unit.Value = data_chart.chart_hour.Summary_Unit['sum_value']
                daplot.summary_unit.CO2 = data_chart.chart_hour.Summary_Unit['sum_co2']
                setChart_plot(daplot)
            } else {
                setChart_plot(daplot)
            }
        } else if (chart_mode === "monthly") {
            daplot = {
                XLabel: data_chart.chart_month.XLabel,
                Energy: [],
                Energy_onpeak: [],
                Energy_offpeak: [],
                PR: [],
                PRG: [],
                ORx: [],
                ORG: [],
                ENS: [],
                Saving: [],
                Saving_onpeak: [],
                Saving_offpeak: [],
                Saving_ft: [],
                Value: [],
                Value_onpeak: [],
                Value_offpeak: [],
                Value_ft: [],
                CO2: [],
                errorx: [],
                CODData: { CODIndex_Start: data_chart.chart_month.CODData.CODIndex_Start, CODIndex_Stop: data_chart.chart_month.CODData.CODIndex_Stop },
                Chart1_Style: { unit: "kWh", digit: 2, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null },
                Chart2_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null },
                Chart3_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null },
                Chart4_Style: { unit: "KWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null },
                Chart5_Style: { unit: "kgCO<sub>2</sub>", digit: 3, type: "column", axis_y1: 'CO2 Reduction (kgCO2)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null },
                Chart6_Style: { unit: "THB", digit: 2, type: "column", axis_y1: 'Saving (THB)', xinterval: 'day', xformat: 'DD', yformat: '#0.###,.k', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null },
                Chart7_Style: { unit: "THB", digit: 2, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'day', xformat: 'DD', yformat: '#0.###,.k', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null },
                summary: { Energy: 0, PRx: 0, ORx: 0, ENS: 0, Saving: 0, Value: 0, CO2: 0 },
                summary_unit: { Energy: "-", PRx: "-", ORx: "-", ENS: "-", Saving: "-", Value: "-", CO2: "-", },
                unit_rate_onpeak: [],
                unit_rate_offpeak: [],
                ft_val: [],
                co2_factor: [],
                holiday: []
            }
            if (data_chart.chart_month.Data[0] !== undefined) {
                daplot.Chart2_Style.start = new Date(data_chart.chart_month.Data[0].x)
                daplot.Chart3_Style.start = new Date(data_chart.chart_month.Data[0].x)
                for (let i = 0; i < data_chart.chart_month.Data.length; i++) {
                    const dx = new Date(data_chart.chart_month.Data[i].x)

                    daplot.Energy.push({ x: dx, y: data_chart.chart_month.Data[i]['solar'] })
                    daplot.Energy_onpeak.push(data_chart.chart_month.Data[i]['solar_onpeak'])
                    daplot.Energy_offpeak.push(data_chart.chart_month.Data[i]['solar_offpeak'])
                    daplot.PR.push({ x: dx, y: data_chart.chart_month.Data[i]['pr_ens'] })
                    daplot.PRG.push({ x: dx, y: data_chart.chart_month.Data[i]['prg'] })
                    daplot.ORx.push({ x: dx, y: data_chart.chart_month.Data[i]['orx_ens'] })
                    daplot.ORG.push({ x: dx, y: data_chart.chart_month.Data[i]['org'] })
                    daplot.ENS.push({ x: dx, y: data_chart.chart_month.Data[i]['ens'] })
                    daplot.Saving.push({ x: dx, y: data_chart.chart_month.Data[i]['saving'] })
                    daplot.Saving_onpeak.push(data_chart.chart_month.Data[i]['saving_onpeak'])
                    daplot.Saving_offpeak.push(data_chart.chart_month.Data[i]['saving_offpeak'])
                    daplot.Saving_ft.push(data_chart.chart_month.Data[i]['saving_ft'])
                    daplot.Value.push({ x: dx, y: data_chart.chart_month.Data[i]['value'] })
                    daplot.Value_onpeak.push(data_chart.chart_month.Data[i]['value_onpeak'])
                    daplot.Value_offpeak.push(data_chart.chart_month.Data[i]['value_offpeak'])
                    daplot.Value_ft.push(data_chart.chart_month.Data[i]['value_ft'])
                    daplot.CO2.push({ x: dx, y: data_chart.chart_month.Data[i]['co2'] })

                    daplot.unit_rate_onpeak.push(data_chart.chart_month.Data[i]['unit_rate_onpeak'])
                    daplot.unit_rate_offpeak.push(data_chart.chart_month.Data[i]['unit_rate_offpeak'])
                    daplot.ft_val.push(data_chart.chart_month.Data[i]['ft_val'])
                    daplot.co2_factor.push(data_chart.chart_month.Data[i]['co2_factor'])
                    daplot.errorx.push(data_chart.chart_month.Data[i]['error'])
                    daplot.holiday.push(data_chart.chart_month.Data[i]['holiday'])
                }
                daplot.summary.Energy = data_chart.chart_month.Summary['sum_energy']
                daplot.summary.PRx = data_chart.chart_month.Summary['pr_ens']
                daplot.summary.ORx = data_chart.chart_month.Summary['orx_ens']
                daplot.summary.ENS = data_chart.chart_month.Summary['sum_ens']
                daplot.summary.Saving = data_chart.chart_month.Summary['sum_saving']
                daplot.summary.Value = data_chart.chart_month.Summary['sum_value']
                daplot.summary.CO2 = data_chart.chart_month.Summary['sum_co2']

                daplot.summary_unit.Energy = data_chart.chart_month.Summary_Unit['sum_energy']
                daplot.summary_unit.PRx = data_chart.chart_month.Summary_Unit['pr_ens']
                daplot.summary_unit.ORx = data_chart.chart_month.Summary_Unit['orx_ens']
                daplot.summary_unit.ENS = data_chart.chart_month.Summary_Unit['sum_ens']
                daplot.summary_unit.Saving = data_chart.chart_month.Summary_Unit['sum_saving']
                daplot.summary_unit.Value = data_chart.chart_month.Summary_Unit['sum_value']
                daplot.summary_unit.CO2 = data_chart.chart_month.Summary_Unit['sum_co2']
                setChart_plot(daplot)
            } else {
                setChart_plot(daplot)
            }
        } else if (chart_mode === "yearly") {
            daplot = {
                XLabel: data_chart.chart_year.XLabel,
                Energy: [],
                Energy_onpeak: [],
                Energy_offpeak: [],
                PR: [],
                PRG: [],
                ORx: [],
                ORG: [],
                ENS: [],
                Saving: [],
                Saving_onpeak: [],
                Saving_offpeak: [],
                Saving_ft: [],
                Value: [],
                Value_onpeak: [],
                Value_offpeak: [],
                Value_ft: [],
                CO2: [],
                errorx: [],
                CODData: { CODIndex_Start: data_chart.chart_year.CODData.CODIndex_Start, CODIndex_Stop: data_chart.chart_year.CODData.CODIndex_Stop },
                Chart1_Style: { unit: "MWh", digit: 3, type: "column", axis_y1: 'Solar Energy (MWh)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null },
                Chart2_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null },
                Chart3_Style: { unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null },
                Chart4_Style: { unit: "MWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (MWh)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null },
                Chart5_Style: { unit: "tonCO<sub>2</sub>", digit: 3, type: "column", axis_y1: 'CO2 Reduction (tonCO2)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null },
                Chart6_Style: { unit: "THB", digit: 2, type: "column", axis_y1: 'Saving (THB)', xinterval: 'month', xformat: 'MMM', yformat: '#0.###,.k', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null },
                Chart7_Style: { unit: "THB", digit: 2, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'month', xformat: 'MMM', yformat: '#0.###,.k', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null },
                summary: { Energy: 0, PRx: 0, ORx: 0, ENS: 0, Saving: 0, Value: 0, CO2: 0 },
                summary_unit: { Energy: "-", PRx: "-", ORx: "-", ENS: "-", Saving: "-", Value: "-", CO2: "-", },
                unit_rate_onpeak: [],
                unit_rate_offpeak: [],
                ft_val: [],
                co2_factor: []
            }
            if (data_chart.chart_year.Data[0] !== undefined) {
                daplot.Chart2_Style.start = new Date(data_chart.chart_year.Data[0].x)
                daplot.Chart3_Style.start = new Date(data_chart.chart_year.Data[0].x)
                for (let i = 0; i < data_chart.chart_year.Data.length; i++) {
                    const dx = new Date(data_chart.chart_year.Data[i].x)

                    daplot.Energy.push({ x: dx, y: data_chart.chart_year.Data[i]['solar'] })
                    daplot.Energy_onpeak.push(data_chart.chart_year.Data[i]['solar_onpeak'])
                    daplot.Energy_offpeak.push(data_chart.chart_year.Data[i]['solar_offpeak'])
                    daplot.PR.push({ x: dx, y: data_chart.chart_year.Data[i]['pr_ens'] })
                    daplot.PRG.push({ x: dx, y: data_chart.chart_year.Data[i]['prg'] })
                    daplot.ORx.push({ x: dx, y: data_chart.chart_year.Data[i]['orx_ens'] })
                    daplot.ORG.push({ x: dx, y: data_chart.chart_year.Data[i]['org'] })
                    daplot.ENS.push({ x: dx, y: data_chart.chart_year.Data[i]['ens'] })
                    daplot.Saving.push({ x: dx, y: data_chart.chart_year.Data[i]['saving'] })
                    daplot.Saving_onpeak.push(data_chart.chart_year.Data[i]['saving_onpeak'])
                    daplot.Saving_offpeak.push(data_chart.chart_year.Data[i]['saving_offpeak'])
                    daplot.Saving_ft.push(data_chart.chart_year.Data[i]['saving_ft'])
                    daplot.Value.push({ x: dx, y: data_chart.chart_year.Data[i]['value'] })
                    daplot.Value_onpeak.push(data_chart.chart_year.Data[i]['value_onpeak'])
                    daplot.Value_offpeak.push(data_chart.chart_year.Data[i]['value_offpeak'])
                    daplot.Value_ft.push(data_chart.chart_year.Data[i]['value_ft'])
                    daplot.CO2.push({ x: dx, y: data_chart.chart_year.Data[i]['co2'] })

                    daplot.unit_rate_onpeak.push(data_chart.chart_year.Data[i]['unit_rate_onpeak'])
                    daplot.unit_rate_offpeak.push(data_chart.chart_year.Data[i]['unit_rate_offpeak'])
                    daplot.ft_val.push(data_chart.chart_year.Data[i]['ft_val'])
                    daplot.co2_factor.push(data_chart.chart_year.Data[i]['co2_factor'])
                    daplot.errorx.push(data_chart.chart_year.Data[i]['error'])
                }
                daplot.summary.Energy = data_chart.chart_year.Summary['sum_energy']
                daplot.summary.PRx = data_chart.chart_year.Summary['pr_ens']
                daplot.summary.ORx = data_chart.chart_year.Summary['orx_ens']
                daplot.summary.ENS = data_chart.chart_year.Summary['sum_ens']
                daplot.summary.Saving = data_chart.chart_year.Summary['sum_saving']
                daplot.summary.Value = data_chart.chart_year.Summary['sum_value']
                daplot.summary.CO2 = data_chart.chart_year.Summary['sum_co2']

                daplot.summary_unit.Energy = data_chart.chart_year.Summary_Unit['sum_energy']
                daplot.summary_unit.PRx = data_chart.chart_year.Summary_Unit['pr_ens']
                daplot.summary_unit.ORx = data_chart.chart_year.Summary_Unit['orx_ens']
                daplot.summary_unit.ENS = data_chart.chart_year.Summary_Unit['sum_ens']
                daplot.summary_unit.Saving = data_chart.chart_year.Summary_Unit['sum_saving']
                daplot.summary_unit.Value = data_chart.chart_year.Summary_Unit['sum_value']
                daplot.summary_unit.CO2 = data_chart.chart_year.Summary_Unit['sum_co2']
                setChart_plot(daplot)
            } else {
                setChart_plot(daplot)
            }
        }
    }, [chart_mode, data_chart]);

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-chart-pie color-orange"></i> System Performance</h4>
                                    <p className="mb-1">Performance of energy production</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {props.server_update !== "-" ? moment(new Date(props.server_update)).format("YYYY-MM-DD HH:mm:ss") : "Unknown"}</h6>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="d-flex justify-content-start gap-1 mt-0 mb-2">
                            <div className="d-block align-self-end">
                                <div className="d-flex gap-1 mt-3 mt-lg-0" style={{ marginBottom: "3px" }}>
                                    <button className={"btn btn-sm " + (chart_mode === "daily-h" ? "btn-info" : "btn-light")} type="button" onClick={e => setChart_mode('daily-h')}>Daily</button>
                                    <button className={"btn btn-sm " + (chart_mode === "monthly" ? "btn-info" : "btn-light")} type="button" onClick={e => setChart_mode('monthly')}>Monthly</button>
                                    <button className={"btn btn-sm " + (chart_mode === "yearly" ? "btn-info" : "btn-light")} type="button" onClick={e => setChart_mode('yearly')}>Yearly</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-1" >
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Solar Energy</h5>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.Energy}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.Energy}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <CanvasJSReact_ChartPerformance
                                            xlabel={chart_plot.XLabel}
                                            plotdata={chart_plot.Energy}
                                            tooltip_onpeak={chart_plot.Energy_onpeak}
                                            tooltip_offpeak={chart_plot.Energy_offpeak}
                                            plotcolor="#2ECC71"
                                            plotname="Solar Energy"
                                            chart_style={chart_plot.Chart1_Style}
                                            cod={chart_plot.CODData}
                                            max={null}
                                            interval={null}
                                            holiday={chart_plot.holiday}
                                            prefix_tool={""}
                                        ></CanvasJSReact_ChartPerformance>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-1">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Performance Ratio</h5>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.PRx >= 100 ? "100" : chart_plot.summary.PRx}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.PRx}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.PR}
                                        plotcolor="#3498DB"
                                        plotname="Performance Ratio"
                                        plotcolor2="#E94646"
                                        plotname2="PR Guarantee"
                                        plotdata2={chart_plot.PRG}
                                        chart_style={chart_plot.Chart2_Style}
                                        cod={chart_plot.CODData}
                                        max={120}
                                        interval={20}
                                        error={chart_plot.errorx}
                                        holiday={chart_plot.holiday}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-1">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Operation Ratio</h5>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.ORx >= 100 ? "100" : chart_plot.summary.ORx}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.ORx}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.ORx}
                                        plotcolor="#3498DB"
                                        plotname="Operation Ratio"
                                        plotcolor2="#E94646"
                                        plotname2="OR Guarantee"
                                        plotdata2={chart_plot.ORG}
                                        chart_style={chart_plot.Chart3_Style}
                                        cod={chart_plot.CODData}
                                        max={120}
                                        interval={20}
                                        error={chart_plot.errorx}
                                        holiday={chart_plot.holiday}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-1">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Energy not Supply</h5>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.ENS}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.ENS}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.ENS}
                                        plotcolor="#566573"
                                        plotname="Energy not Supply"
                                        chart_style={chart_plot.Chart4_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        error={chart_plot.errorx}
                                        holiday={chart_plot.holiday}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common">
                                <div className="card-body pb-1">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> CO<sub>2</sub> Reduction</h5>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.CO2}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.CO2}CO<sub>2</sub>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.CO2}
                                        plotcolor="#8E44AD"
                                        plotname="CO2 Reduction"
                                        chart_style={chart_plot.Chart5_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        co2factor={chart_plot.co2_factor}
                                        holiday={chart_plot.holiday}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-1">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Estimate Saving</h5>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.Saving}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.Saving}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.Saving}
                                        tooltip_onpeak={chart_plot.Saving_onpeak}
                                        tooltip_offpeak={chart_plot.Saving_offpeak}
                                        tooltip_usage={chart_plot.Saving_usage}
                                        tooltip_ft={chart_plot.Saving_ft}
                                        plotcolor="#F1C40F"
                                        plotname="Estimate Saving"
                                        chart_style={chart_plot.Chart6_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        unitrate={chart_plot.unit_rate}
                                        unitrate_onpeak={chart_plot.unit_rate_onpeak}
                                        unitrate_offpeak={chart_plot.unit_rate_offpeak}
                                        ft_val={chart_plot.ft_val}
                                        holiday={chart_plot.holiday}
                                        prefix_tool={"Discount"}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 col-xxxl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-1">
                                    <div className='d-flex  justify-content-between mb-2'>
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Estimate Energy Value</h5>
                                        <div className="performance-box">
                                            <div className="performance-value">
                                                <div className="performance-number">
                                                    {chart_plot.summary.Value}
                                                </div>
                                                <div className="performance-unit">
                                                    {chart_plot.summary_unit.Value}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CanvasJSReact_ChartPerformance
                                        xlabel={chart_plot.XLabel}
                                        plotdata={chart_plot.Value}
                                        tooltip_onpeak={chart_plot.Value_onpeak}
                                        tooltip_offpeak={chart_plot.Value_offpeak}
                                        tooltip_usage={chart_plot.Value_usage}
                                        tooltip_ft={chart_plot.Value_ft}
                                        plotcolor="#3498DB"
                                        plotname="Estimate Energy Value"
                                        chart_style={chart_plot.Chart7_Style}
                                        cod={chart_plot.CODData}
                                        max={null}
                                        interval={null}
                                        unitrate={chart_plot.unit_rate}
                                        unitrate_onpeak={chart_plot.unit_rate_onpeak}
                                        unitrate_offpeak={chart_plot.unit_rate_offpeak}
                                        ft_val={chart_plot.ft_val}
                                        holiday={chart_plot.holiday}
                                        prefix_tool={""}
                                    ></CanvasJSReact_ChartPerformance>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <ScrollToTopButton />
        </div>
    )
}
export default MeasurementPerformance